export default {
  apiUrl: "https://operation-api.koletra.com/api",
  supportPanelImgUrl: "https://api.koletra.com",
}
